import React from 'react';
import { Badge, Card, CardBody, CardImg } from 'reactstrap';
import { Game, Platform } from '../types';

interface GameCardProps {
    game: Game;
    onPlatformClick: (platform: Platform) => void;
}

export const GameCard: React.FC<GameCardProps> = ({ game, onPlatformClick }) => (
    <Card className="h-100 shadow">
        <Badge
            color="dark"
            className="position-absolute"
            style={{ top: '0.5rem', right: '0.5rem' }}
            onClick={() => onPlatformClick(game.platform)}>
            {game.platform.name}
        </Badge>
        <CardImg src={game.image} alt="..." loading="lazy" top />
        <CardBody className="p-4">
            <div className="text-center">{game.name}</div>
        </CardBody>
    </Card>
);
